import Vue from "vue";

export let mixinFormatter = {
  data() {
    return {
      colors: ['var(--blue)', 'var(--ligtGreen)', 'var(--red)'],
      colorsTwo: ['var(--red)', 'var(--ligtGreen)'],
      vm: null
    };
  },
  components: {
  },
  mounted() {
    this.vm = new Vue()
  },
  methods: {
    format_status_iss(row, column, cellValue, index) {
      const h = this.vm.$createElement
      return h('span', {
      }, cellValue != null ? this.$store.state.iss[cellValue].label : '')
    },
    format_status(row, column, cellValue, index) {
      const h = this.vm.$createElement
      return h('span', {
        // attrs: {
        //   href: 'http://www.baidu.com'
        // },
        style: {
          color: this.colors[cellValue]
        }
      }, this.$store.state.applyStatus1[cellValue].label)
    },
    format_status_str(row, column, cellValue, index) {
      const h = this.vm.$createElement
      let obj = null, arri = 0
      this.$store.state.applyStatus.map((item, i) => {
        if (cellValue == item.value) {
          obj = item
          arri = i
        }
      })
      return h('span', {
        style: {
          color: this.colors[arri]
        }
      }, obj.label)
    },
    format_status_open_close(row, column, cellValue, index) {
      const h = this.vm.$createElement
      let obj = null, arri = 0
      this.$store.state.isOpens.map((item, i) => {
        if (cellValue == item.value) {
          obj = item
          arri = i
        }
      })
      return h('span', {
        style: {
          color: this.colorsTwo[arri],
          fontWeight: 'bold'
        }
      }, obj.label)
    },
    format_arr(row, column, cellValue, index) {
      // console.log(row, column, cellValue, index)
      let arrName = column['labelClassName'] || column['label-class-name']
      let needColor = column['need-color'] == false ? false : true
      const h = this.vm.$createElement
      let obj = null, arri = 0
      this.$store.state[arrName].map((item, i) => {
        if (cellValue == item.value) {
          obj = item
          arri = i
        }
      })
      if (obj && obj.label) {
        return h('span', {
          style: {
            color: !needColor?this.colors[arri]:''
          }
        }, obj.label)

      } else {

        return h('span', {
          style: {
            // color: this.colors[arri]
          }
        }, cellValue)
      }
    },
  }
};
